'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bcSafeLog = require('@alife/bc-safe-log');

var _bcSafeLog2 = _interopRequireDefault(_bcSafeLog);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Log = function () {
  function Log(el, config) {
    var _this = this;

    _classCallCheck(this, Log);

    if (!el) {
      (0, _utils.safeThrow)(new Error('Video element is required!'));
      return;
    }

    this.elVideo = el;
    this.config = _extends({
      logId: 'bcAlphaTbplayer',
      enoughTime: 3000
    }, config);

    var _config = this.config,
        logPara = _config.logPara,
        videoId = _config.videoId,
        productid = _config.productid,
        companyid = _config.companyid,
        scene = _config.scene,
        duration = _config.duration,
        hasVideoElement = _config.hasVideoElement;

    var vid = videoId || (0, _utils.getVideoId)(this.elVideo);
    var videoDuration = this.elVideo.duration || duration;
    this.commonLogPara = (0, _utils.addParam)(logPara, 'videoId=' + vid, 'scene=' + scene, 'playsid=' + (0, _utils.getPlaysid)(), 'preload=' + this.elVideo.preload, 'autoplay=' + this.elVideo.autoplay, videoDuration && 'videoduration=' + videoDuration, productid && 'productid=' + productid, companyid && 'companyid=' + companyid);

    this.times = {};
    this.totalPlayTime = 0;
    this._logPlayTime = this._logPlayTime.bind(this);

    // 对于使用原生video的视频会在开始加载时打点
    if (!hasVideoElement) {
      this.once('loadstart', function () {
        _this.setTime('beginLoadTime');
      });
    }

    if (!this.elVideo.duration) {
      this.once('loadedmetadata', function () {
        if (_this.times.beginLoadTime) {
          var loadTime = Date.now() - _this.times.beginLoadTime;
          _this.times.redirectTime = _this.getRedirectTime();
          _this.log('control', 'EXP', 'loadTime=' + loadTime + (_this.times.redirectTime >= 0 ? '&redirectTime=' + _this.times.redirectTime : ''));
        }
        _this.commonLogPara = (0, _utils.addParam)(_this.commonLogPara, 'videoduration=' + _this.elVideo.duration);
      });
    } else {
      this.setTime('beginLoadTime');
      var loadTime = Date.now() - this.times.beginLoadTime;
      this.times.redirectTime = this.getRedirectTime();
      this.log('control', 'EXP', 'loadTime=' + loadTime + (this.times.redirectTime >= 0 ? '&redirectTime=' + this.times.redirectTime : ''));
      this.commonLogPara = (0, _utils.addParam)(this.commonLogPara, 'videoduration=' + this.elVideo.duration);
    }

    this.logExpose();
    this.logControls();
    this.logPerf();
  }

  Log.prototype.getRedirectTime = function getRedirectTime() {
    var videoId = this.config.videoId;

    if (window.performance && window.performance.getEntries) {
      var redirectItem = window.performance.getEntries().find(function (item) {
        return item.name.indexOf('cloud.video.alibaba.com') > -1 && Number((0, _utils.getVideoIdBySrc)(item.name)) === Number(videoId);
      });
      return redirectItem && redirectItem.fetchStart - redirectItem.startTime;
    }
  };

  Log.prototype.on = function on(event, func) {
    this.elVideo.addEventListener(event, func);
  };

  Log.prototype.once = function once(event, func) {
    (0, _utils.once)(this.elVideo, event, func);
  };

  Log.prototype.log = function log(key, type, param) {
    var _config2 = this.config,
        logId = _config2.logId,
        duration = _config2.duration;

    var videoDuration = this.elVideo.duration || duration;
    var progress = videoDuration && (this.elVideo.currentTime / videoDuration).toFixed(2);
    var params = (0, _utils.addParam)(this.commonLogPara, 'progress=' + (progress || 0), 'volume=' + (this.elVideo.muted ? 0 : this.elVideo.volume.toFixed(2)), param);
    (0, _bcSafeLog2['default'])('/sc.' + logId + '.' + key, type, params);
  };

  Log.prototype.setTime = function setTime(name, value) {
    this.times[name] = value === undefined ? Date.now() : value;
  };

  Log.prototype.logExpose = function logExpose() {
    var _this2 = this;

    this.log('expose', 'EXP');

    // 播放完成
    this.on('ended', function () {
      _this2.log('control', 'CLK', 'action=ended');
      _this2._logPlayTime();
    });

    // unload时更新播放时间
    window.addEventListener('beforeunload', this._logPlayTime);
  };

  Log.prototype.logControls = function logControls() {
    var _this3 = this;

    // 暂停播放，过滤掉视频结束时的自动暂停
    this.on('pause', function () {
      if (_this3.elVideo.ended) {
        return;
      }
      _this3.log('control', 'CLK', 'action=pause');
      _this3._logPlayTime();
      _this3._logWaitTime();
    });

    // 原生video标签自动播放的视频以视频开始加载时间计算
    if (this.elVideo.autoplay && !this.config.hasVideoElement) {
      this.log('play', 'EXP');
      this.once('loadstart', function () {
        _this3.setTime('firstPlayTime');
      });
    }

    // 如果视频在js执行时已经开始播放了，这里补充打点
    if (!this.elVideo.paused && this.elVideo.currentTime > 0) {
      this.log('play', this.elVideo.autoplay ? 'EXP' : 'CLK');
      this.setTime('beginPlayTime');
    }

    this.on('play', function () {
      if (!_this3.times.firstPlayTime) {
        _this3.log('play', _this3.elVideo.autoplay ? 'EXP' : 'CLK');
        _this3.setTime('firstPlayTime');
        _this3.setTime('beginPlayTime');
        _this3.setTime('beginLoadTime');
        return;
      }
      !_this3.elVideo.seeking && _this3.log('control', 'CLK', 'action=replay');
    });

    // 进度调整
    this.on('seeking', function () {
      _this3.setTime('seeking');
      _this3.log('control', 'CLK', 'action=seeking');
      _this3._logPlayTime();
    });

    // 音量调整
    this.on('volumechange', function () {
      _this3.log('control', 'CLK', 'action=volumechange');
    });

    // 全屏播放
    var logFullScreen = function logFullScreen(fullScreen) {
      _this3.log('control', 'CLK', 'action=fullscreenchange&fullscreen=' + !!fullScreen);
    };
    (0, _utils.onFullScreenChange)(this.elVideo.parentNode, function () {
      return logFullScreen((0, _utils.isFullScreen)(_this3.elVideo.parentNode));
    });
  };

  Log.prototype.logPerf = function logPerf() {
    var _this4 = this;

    var updateTime = void 0;
    this.isInView = (0, _utils.isInView)(this.elVideo);
    this.on('timeupdate', function () {
      var timeNow = Date.now();
      if (!updateTime) {
        updateTime = timeNow;
        return;
      }
      if (_this4.elVideo.paused) {
        updateTime = timeNow;
        return;
      }
      if (!_this4.times.firstFrame) {
        _this4.setTime('firstFrame');

        var _ref = window.bcAlphaTbplayer || {},
            preloadTime = _ref.preloadTime;

        _this4.log('control', 'EXP', 'action=firstframe&frameloadtime=' + (_this4.times.firstFrame - _this4.times.firstPlayTime) + (preloadTime ? '&preloadTime=' + preloadTime : ''));
      }

      if (timeNow - updateTime < 100) {
        return;
      }
      updateTime = timeNow;
      var visible = (0, _utils.isInView)(_this4.elVideo);
      if (_this4.isInView === visible) {
        // 正常播放中每enoughTime打一次，以避免日志漏发
        if (updateTime - _this4.times.beginPlayTime > _this4.config.enoughTime) {
          _this4._logPlayTime();
          _this4.setTime('beginPlayTime');
        }
        return;
      }
      _this4.isInView = visible;
      _this4._logPlayTime();
      _this4.setTime('beginPlayTime');
    });

    // 卡顿率
    this.on('waiting', function () {
      if (_this4.elVideo.seeking) {
        return;
      }
      _this4.setTime('waiting');
      _this4._logPlayTime();
    });
    this.on('seeked', function () {
      _this4._logWaitTime();
      /*
       * 主流浏览器会在seeked后有playing方法，IE没有
       * 这里在seeked记录一次卡顿时间，如果seeked跟playing之间再有卡顿会发出第二个卡顿打点
       * IE只发本次卡顿，seeked跟playing之间的卡顿会漏掉
      */
      _this4.setTime('waiting');
    });
    this.on('playing', function () {
      _this4.setTime('beginPlayTime');
      _this4._logWaitTime();
    });

    // 错误率
    this.on('error', function () {
      var _ref2 = _this4.elVideo.error || {},
          message = _ref2.message,
          code = _ref2.code;

      _this4.log('control', 'EXP', 'action=error&msg=' + (message || code || '404'));
      _this4._logPlayTime();
      _this4._logWaitTime();
    });

    this.on('stalled', function () {
      _this4.log('control', 'EXP', 'action=error&msg=stalled');
      _this4._logPlayTime();
      _this4._logWaitTime();
    });
  };

  Log.prototype._logPlayTime = function _logPlayTime() {
    if (!this.times.beginPlayTime) {
      return;
    }

    var interval = Date.now() - this.times.beginPlayTime;
    this.setTime('beginPlayTime', null);
    if (!interval || interval < _utils.CONSTS.MAX_WAIT_TIME) {
      return;
    }

    this.totalPlayTime += interval;
    this.log('control', 'EXP', 'action=playtime&playtime=' + interval + '&visible=' + this.isInView + '&totalPlayTime=' + this.totalPlayTime);
    if (!this._enoughTimeLoged && this.totalPlayTime >= this.config.enoughTime) {
      this.log('enoughtime', 'EXP', 'enoughtime=' + this.config.enoughTime);
      this._enoughTimeLoged = true;
    }
  };

  Log.prototype._logWaitTime = function _logWaitTime() {
    if (!this.times.waiting) {
      return;
    }

    var interval = Date.now() - this.times.waiting;
    this.setTime('waiting', null);
    if (!interval || interval < _utils.CONSTS.MAX_WAIT_TIME) {
      return;
    }
    this.log('control', 'EXP', 'action=waiting&waitTime=' + interval);
  };

  Log.prototype.destroy = function destroy() {
    window.removeEventListener('beforeunload', this._logPlayTime);
  };

  return Log;
}();

exports['default'] = Log;
module.exports = exports['default'];